











import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: 'CategoryDetails',
  props: {
    details: {type: Array as PropType<String[]>},
    icon: {type: String, default: ''}
  }
})
